import { render, staticRenderFns } from "./translate.vue?vue&type=template&id=e0da775e&"
import script from "./translate.vue?vue&type=script&lang=ts&"
export * from "./translate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports